export enum DeliveryPath {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  VOICE = 'VOICE',
  PUSH = 'PUSH'
}
